import { Component, OnInit } from '@angular/core';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { DatePipe } from '@angular/common';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { SolicitudExService } from '../datosbasicos/datosbasicosEx.service';
import { EnumIdsTcEstadoSolicitudEx, EnumIdsTwTcSubTipoSolicitudEx, EnumModoReasignacion, EnumModoReasignacionDesc } from '../types/enum';
import { EnumCodigosTwTcAcciones, EnumIdsTwTcTipoClonacion } from '../../../_importacion/solicitudes/types/enum';
import { SolicitudSeguimientoExViewModel, TComentarioInspectorExViewModel, THistorialReasignacionPcfExViewModel } from './seguimientoEx.types';
import { SeguimientoExService } from './seguimientoEx.service';

@Component({
    selector: 'app-seguimientosex-list',
    templateUrl: './seguimientosEx-list.component.html',
})
export class SeguimientosExListComponent extends ComponentBase implements OnInit {
    solicitudExSeguimiento: SolicitudSeguimientoExViewModel;
    habilitarGuardar = false;
    idSolicitudEx = 0;
    editMode = false;
    tituloTipoSolicitudEx: string;
    CodigoSolicitud: string;
    CodigoTipoSolicitud: string;
    esClonada = false;

    habilitarNuevoSeguimiento = false;
    seguimientoEditable: boolean;
    seguimientoBorrable: boolean;
    colsObservaciones: any[];

    colsHistorialPcf: any[];

    TComentarioInspectorExCollection: TComentarioInspectorExViewModel[];
    tituloEstadoCertificadoFitoEx: string;
    IdTipoSolicitudEx: number;
    IdSubTipoSolicitudEx: number;
    IdEstadoSolicitudEx: number;
    EstadoSolicitudExDescripcion: string;
    IdSubTipoSolicitudExDescripcion: string;
    IdEstadoCertificadoFitoEx: number;
    IdEstadoCertificadoFitoExDescripcion: string;

    THistorialReasignacionPcfExCollection: THistorialReasignacionPcfExViewModel[];

    tercerPaisConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_TERCER_PAIS_CON_ATEST_FITO;
    reExpConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_REEXPORTACION_CON_ATEST_FITO;
    canariasConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_CANARIAS_CON_ATEST_FITO;

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private navMenuService: NavMenuService,
        private solicitudExService: SolicitudExService,
        private seguimientoExService: SeguimientoExService,
        private confirmationService: ConfirmationService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit() {
        this.colsObservaciones = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'Observaciones', header: 'Descripción' },
            { field: 'Inspector', header: 'Inspector' },
            { field: 'Fecha', header: 'Fecha' },
            { field: 'IdSeccionDescripcion', header: 'Seccion' },
            { field: 'IdMotivoDescripcion', header: 'Motivo' },
        ];

        this.colsHistorialPcf = [
            { field: 'NombrePuntoInspeccion', header: 'Nombre del Punto de Inspección' },
            { field: 'ModoReasignacion', header: 'Modo de Asignación' },
            { field: 'FechaCambioPcf', header: 'Fecha de Cambio PCF' },
        ];

        this.idSolicitudEx = this.activatedRoute.snapshot.params['id'];

        this.guardRefreshPage(this.idSolicitudEx);

        //this.createForm();
        //this.onSearchButton();

        this.seguimientoExService.getSeguimientosEx(this.idSolicitudEx).subscribe(result => {
            this.solicitudExSeguimiento = result;

            this.IdTipoSolicitudEx = this.solicitudExSeguimiento.IdTipoSolicitudEx;
            this.IdSubTipoSolicitudEx = this.solicitudExSeguimiento.IdSubTipoSolicitudEx!;
            this.CodigoSolicitud = this.solicitudExSeguimiento.CodigoSolicitud;
            this.CodigoTipoSolicitud = this.solicitudExSeguimiento.CodigoTipoSolicitud;
            this.IdEstadoSolicitudEx = this.solicitudExSeguimiento.IdEstadoSolicitudEx;
            this.tituloTipoSolicitudEx = this.solicitudExSeguimiento.IdTipoSolicitudExDescripcion;
            this.EstadoSolicitudExDescripcion = this.solicitudExSeguimiento.IdEstadoSolicitudExDescripcion;
            this.IdSubTipoSolicitudExDescripcion = this.solicitudExSeguimiento.IdSubTipoSolicitudExDescripcion;
            this.IdEstadoCertificadoFitoEx = this.solicitudExSeguimiento.IdEstadoCertificadoFitoEx;
            this.IdEstadoCertificadoFitoExDescripcion = this.solicitudExSeguimiento.IdEstadoCertificadoFitoExDescripcion;

            this.esClonada =
                this.solicitudExSeguimiento.TwSolicitudJerarquiaEx != null &&
                this.solicitudExSeguimiento.TwSolicitudJerarquiaEx.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                    ? true
                    : false;

            this.THistorialReasignacionPcfExCollection = this.solicitudExSeguimiento.THistorialReasignacionPcfExCollection;

            //SI ES PREVIA
            if (this.solicitudExSeguimiento.EsPrevia) {
                if (
                    this.solicitudExSeguimiento.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA &&
                    this.solicitudExSeguimiento.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE
                ) {
                    this.tituloTipoSolicitudEx += ' - Previa';
                }
            }

            if (this.isSolicitante) {
                this.TComentarioInspectorExCollection = this.solicitudExSeguimiento.TComentarioInspectorExCollection.filter(t => t.VisibleSolicitante);
            } else {
                this.TComentarioInspectorExCollection = this.solicitudExSeguimiento.TComentarioInspectorExCollection;
            }

            this.habilitarNuevoSeguimiento = this.loggedInUser!.getAction(
                EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO_EXPORTACION,
                this.solicitudExSeguimiento.IdEstadoSolicitudEx,
            ).Editable;

            this.loading = false;
        });
    }

    checkEditSeguimiento(rowData: TComentarioInspectorExViewModel): boolean {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO_EXPORTACION).Editable && rowData.IdInspector == this.loggedInUser!.Id;
    }

    checkDeleteSeguimiento(rowData: TComentarioInspectorExViewModel): boolean {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO_EXPORTACION).Editable && rowData.IdInspector == this.loggedInUser!.Id;
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudExportacion.Id) || this.navMenuService.currentSolicitudExportacion.Id !== id) {
            this.solicitudExService.getSolicitudEx(id).subscribe(result => {
                this.navMenuService.currentSolicitudExportacion = result;
            });
        }
    }

    onBack() {
        this.router.navigate(['/exportacion/solicitud/datosbasicosEx', this.navMenuService.currentSolicitudExportacion.Id]);
    }

    onAddSeguimiento() {
        this.router.navigate([this.router.url, 'createSeguimiento']);
    }

    onEditSeguimiento(item: TComentarioInspectorExViewModel) {
        this.router.navigate([this.router.url, 'detalleseguimiento', item.Id]);
    }

    onDeleteSeguimiento(item: TComentarioInspectorExViewModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.seguimientoExService.deleteSeguimientoEx(item.Id).subscribe(() => {
                    this.addSuccessMessage('Seguimiento eliminado correctamente');
                    //this.onSearchButton();
                    this.ngOnInit();
                });
            },
        });
    }

    get mostrarHistorial(): boolean {
        return this.THistorialReasignacionPcfExCollection?.length > 1;
    }

    public obtenerTextoModoReasignacion(modo: string | null): string {
        switch (modo) {
            case EnumModoReasignacion.Automatica:
                return EnumModoReasignacionDesc.Automatica;
            case EnumModoReasignacion.Manual:
                return EnumModoReasignacionDesc.Manual;
            case EnumModoReasignacion.Inicial:
                return EnumModoReasignacionDesc.Inicial;
            case EnumModoReasignacion.Sistema:
                return EnumModoReasignacionDesc.Sistema;
            default:
                return EnumModoReasignacionDesc.Inicial; // Manejo para valores nulos o inesperados
        }
    }
}
